import React from 'react';
import AssemblyAITranscribe from '@/components/AssemblyAI/AssemblyAITranscribe';

const AssemblyAITranscribePage: React.FC = () => {
  return (
    <div style={{ padding: 16 }}>
      <AssemblyAITranscribe />
    </div>
  );
};

export default AssemblyAITranscribePage;
